export default __webpack_public_path__ + "static/media/image2.4006c428.jpeg";